var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component"},[_c('v-btn',{on:{"click":_vm.setMessagingToken}},[_vm._v("setMessagingToken")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }